import { CommonModule } from '@angular/common';
import { Component, Inject } from '@angular/core';
import {
  MAT_DIALOG_DATA,
  MatDialogModule,
  MatDialogRef,
} from '@angular/material/dialog';
import { EditRoomComponent } from '@mandants/telekom/features/edit-room/edit-room.component';
import { WorkingSpaceComponent } from '@mandants/telekom/features/locationServices/working-space/working-space.component';

@Component({
  selector: 'app-edit-room-dialog',
  template: `
    <div class="dialog-wrapper">
      <ng-container [ngSwitch]="data.dialogComp">
        <app-edit-room
          *ngSwitchCase="'edit-room'"
          [roomId]="data.roomId"
          [isEmbedded]="true"
          (closeEmbeddedView)="onCloseDialog()"
          (navigateToWorkspace)="onNavigateToWorkspace($event)">
        </app-edit-room>

        <app-working-space
          class="working-space-dialog-container"
          *ngSwitchCase="'working-space'"
          [workspaceId]="selectedNodeId"
          [isEmbedded]="true"
          (closeEmbeddedView)="onCloseDialog()">
        </app-working-space>
      </ng-container>
    </div>
  `,
  styles: [
    `
      .dialog-wrapper {
        width: 900px;
        height: 85vh;
        padding: 20px;
        box-sizing: border-box;
        overflow: auto;
      }

      .dialog-wrapper:has(.working-space-dialog-container) {
        width: 100%;
      }
    `,
  ],
  imports: [
    CommonModule,
    EditRoomComponent,
    MatDialogModule,
    WorkingSpaceComponent,
  ],
  standalone: true,
})
export class EditRoomDialogComponent {
  selectedNodeId: string;
  constructor(
    public dialogRef: MatDialogRef<EditRoomDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { roomId: string; dialogComp: string }
  ) {
    if (this.data.dialogComp == 'working-space') {
      this.selectedNodeId = this.data.roomId;
    }
  }

  onCloseDialog(): void {
    this.dialogRef.close();
  }

  onNavigateToWorkspace(workspaceId: string): void {
    // Schließe den Dialog und gebe die Workspace-ID zurück
    this.selectedNodeId = workspaceId;
    this.data.dialogComp = 'working-space';
  }
}
